import React from "react";
import { CommonErrorPopup, ConfirmationPopup } from "component-library";
import { useTranslation } from "i18n";
import { useGetIgApiAuthUrl } from "../hooks/useGetIgApiAuthUrl";
import { AuthInstagramIntegrationCode } from "shared-types";
import { useDisconnectInstagramAccount } from "../hooks/useDisconnectInstagramAccount";

interface Props {
  profileId: string;
  instagramAccountId: number;
  close: () => void;
}

const ReconnectInstagramPopUp = ({
  profileId,
  instagramAccountId,
  close,
}: Props) => {
  const { t } = useTranslation();

  const { data, isLoading, error } = useGetIgApiAuthUrl(profileId);
  const {
    mutateAsync: mutateDisconnect,
    isLoading: disconnectIsLoading,
    error: disconnectError,
    reset,
  } = useDisconnectInstagramAccount({
    profileId,
    instagramAccountId,
  });

  const handleClosePopUp = async () => {
    await mutateDisconnect();
    close();
  };

  if (error)
    return (
      <CommonErrorPopup
        errorStatusCode={
          error?.response?.status || disconnectError?.response?.status
        }
        popupProps={{
          close: () => {
            reset();
            close();
          },
        }}
        alertMessageProps={{
          buttons: [
            {
              type: "primary",
              name: t("common:button.label.close"),
              click: close,
            },
          ],
        }}
        errorCode={
          disconnectError
            ? AuthInstagramIntegrationCode.Disconnect
            : AuthInstagramIntegrationCode.Reconnect
        }
      />
    );

  return (
    <ConfirmationPopup
      texts={{
        title: t("performer:profile.socialMedia.instagram.reconnect.title"),
        description: t(
          "performer:profile.socialMedia.instagram.reconnect.text"
        ),
        proceed: t("performer:profile.socialMedia.instagram.reconnect.proceed"),
        cancel: t("performer:profile.socialMedia.instagram.reconnect.cancel"),
      }}
      handleProceed={() => {
        window.open(data, "ig-login", "width=500,height=700");
      }}
      loading={isLoading || disconnectIsLoading}
      handleCancel={handleClosePopUp}
    />
  );
};

export default ReconnectInstagramPopUp;
